import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'
import {
  actionCreators,
  IChangePasswordState,
} from '../modules/changePassword'

type ChangePasswordModalProps = IChangePasswordState &
  typeof actionCreators &
  ICurrentUserState

export class ChangePasswordModal extends React.PureComponent<
  ChangePasswordModalProps
> {
  constructor(props: ChangePasswordModalProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <Modal
        centered
        isOpen={this.props.isOpen}
        onClosed={this._onModalClosed}
        toggle={this._closeModal}
      >
        <ModalHeader toggle={this._closeModal}>Change Password</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for='oldPassword'>Current Password</Label>
            <Input
              name='oldPassword'
              onChange={this._onChangeOldPassword}
              required
              type='password'
              value={this.props.oldPassword}
            />
          </FormGroup>
          <FormGroup>
            <Label for='newPassword'>New Password</Label>
            <Input
              name='newPassword'
              onChange={this._onChangeNewPassword}
              required
              type='password'
              value={this.props.newPassword}
            />
          </FormGroup>
          <FormGroup>
            <Label for='verifyPassword'>Verify New Password</Label>
            <Input
              invalid={this.props.verifyPassword !== this.props.newPassword}
              name='verifyPassword'
              onChange={this._onChangeVerifyPassword}
              required
              type='password'
              value={this.props.verifyPassword}
            />
            <FormFeedback>
              Verify password should match new password
            </FormFeedback>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={this._closeModal} outline>
            <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Cancel
          </Button>
          <Button
            color='primary'
            disabled={this.props.isSaving || !this.props.isValid}
            onClick={this._updatePassword}
          >
            <FontAwesomeIcon icon={['fal', 'save']} fixedWidth /> Update
            Password
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  private _closeModal() {
    this.props.closeChangePasswordModal()
  }

  private _onChangeOldPassword(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setOldPassword(event.target.value)
  }

  private _onChangeNewPassword(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setNewPassword(event.target.value)
  }

  private _onChangeVerifyPassword(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setVerifyPassword(event.target.value)
  }

  private _onModalClosed() {
    this.props.resetState()
  }

  private _updatePassword() {
    if (this.props.user && this.props.isValid) {
      this.props.updatePassword(
        this.props.user.id,
        this.props.newPassword,
        this.props.oldPassword,
      )
    }
  }
}
